import { useApp } from "../state/store";
import { useT } from "../i18n/store";
import { fmt } from "../domain/units";
import type { Layout } from "../domain/types";

export interface StatusBarProps {
  layout: Layout;
}

export const StatusBar = ({ layout }: StatusBarProps) => {
  const t = useT();
  const sign = useApp((s) => s.sign);
  const total = layout.cols * layout.rows;

  return (
    <div className="status-bar">
      <span>{t("status.layout", { cols: layout.cols, rows: layout.rows })}</span>
      <span className="dot">·</span>
      <span>{t("status.paper", { w: fmt(layout.paper.width), h: fmt(layout.paper.height) })}</span>
      <span className="dot">·</span>
      <span>{t("status.sign", { w: fmt(sign.width), h: fmt(sign.height) })}</span>
      <span className="dot">·</span>
      <span>{t("status.sheets", { n: total })}</span>
    </div>
  );
};
